"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProxyConnectionRpcLocal = void 0;
const dht_1 = require("@streamr/dht");
const utils_1 = require("@streamr/utils");
const eventemitter3_1 = require("eventemitter3");
const NetworkRpc_1 = require("../../../generated/packages/trackerless-network/protos/NetworkRpc");
const NetworkRpc_client_1 = require("../../../generated/packages/trackerless-network/protos/NetworkRpc.client");
const ContentDeliveryRpcRemote_1 = require("../ContentDeliveryRpcRemote");
const logger = new utils_1.Logger(module);
class ProxyConnectionRpcLocal extends eventemitter3_1.EventEmitter {
    options;
    connections = new Map();
    constructor(options) {
        super();
        this.options = options;
        this.options.rpcCommunicator.registerRpcMethod(NetworkRpc_1.ProxyConnectionRequest, NetworkRpc_1.ProxyConnectionResponse, 'requestConnection', (msg, context) => this.requestConnection(msg, context));
    }
    getConnection(nodeId) {
        return this.connections.get(nodeId);
    }
    hasConnection(nodeId) {
        return this.connections.has(nodeId);
    }
    removeConnection(nodeId) {
        this.connections.delete(nodeId);
    }
    stop() {
        this.connections.forEach((connection) => connection.remote.leaveStreamPartNotice(this.options.streamPartId, false));
        this.connections.clear();
        this.removeAllListeners();
    }
    getPropagationTargets(msg) {
        if (msg.body.oneofKind === 'groupKeyRequest') {
            try {
                const recipientId = msg.body.groupKeyRequest.recipientId;
                return this.getNodeIdsForUserId((0, utils_1.toUserId)(recipientId));
            }
            catch (err) {
                logger.trace(`Could not parse GroupKeyRequest`, { err });
                return [];
            }
        }
        else {
            return this.getSubscribers();
        }
    }
    getNodeIdsForUserId(userId) {
        return Array.from(this.connections.keys()).filter((nodeId) => this.connections.get(nodeId).userId === userId);
    }
    getSubscribers() {
        return Array.from(this.connections.keys()).filter((key) => this.connections.get(key).direction === NetworkRpc_1.ProxyDirection.SUBSCRIBE);
    }
    // IProxyConnectionRpc server method
    async requestConnection(request, context) {
        const senderPeerDescriptor = context.incomingSourceDescriptor;
        const remoteNodeId = (0, dht_1.toNodeId)(senderPeerDescriptor);
        this.connections.set(remoteNodeId, {
            direction: request.direction,
            userId: (0, utils_1.toUserId)(request.userId),
            remote: new ContentDeliveryRpcRemote_1.ContentDeliveryRpcRemote(this.options.localPeerDescriptor, senderPeerDescriptor, this.options.rpcCommunicator, NetworkRpc_client_1.ContentDeliveryRpcClient)
        });
        const response = {
            accepted: true
        };
        logger.trace(`Accepted connection request from ${remoteNodeId} to ${this.options.streamPartId}`);
        this.emit('newConnection', remoteNodeId);
        return response;
    }
}
exports.ProxyConnectionRpcLocal = ProxyConnectionRpcLocal;
//# sourceMappingURL=ProxyConnectionRpcLocal.js.map